import { render, staticRenderFns } from "./cardsInvitations.vue?vue&type=template&id=6062b44e&"
import script from "./cardsInvitations.vue?vue&type=script&lang=js&"
export * from "./cardsInvitations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports